import React from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // Check if user is admin
  if (!user || (user.role !== 'admin' && user.role !== 'super_admin')) {
    return <Navigate to="/" replace />;
  }

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: '📊' },
    { path: '/admin/users', label: 'Users', icon: '👥' },
    { path: '/admin/promoters', label: 'Promoters', icon: '🎁' },
    { path: '/admin/blog', label: 'Blog', icon: '📝' },
    { path: '/admin/logs', label: 'Activity Logs', icon: '📋' },
  ];

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-logo">
          <h2>🛡️ Admin</h2>
        </div>
        <nav className="admin-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="admin-nav-icon">{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <Link to="/" className="admin-back-link">
            ← Back to App
          </Link>
        </div>
      </aside>
      <main className="admin-main">
        <header className="admin-header">
          <div className="admin-header-title">
            {navItems.find(item => item.path === location.pathname)?.label || 'Admin'}
          </div>
          <div className="admin-header-user">
            <span className="admin-role-badge">
              {user.role === 'super_admin' ? '👑 Super Admin' : '🛡️ Admin'}
            </span>
            <span>{user.firstName} {user.lastName}</span>
          </div>
        </header>
        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
